import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";
// SYSTEM-1
import { IEngagementActivity } from "@/store/models/engagements/engagementActivity";
import { EngagementActivityNoteModel } from "@/store/models/engagements/engagementActivityNote";
import EngagementsModule from "@/store/modules/engagements.module";
import BaseMixer from "../../BaseMixer";
import { toaster } from "@/utilities/toaster";
let StageActivityNotes = /** @class */ (() => {
    var _a;
    let StageActivityNotes = class StageActivityNotes extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isEditing = false;
            this.engagementActivityNote = new EngagementActivityNoteModel();
        }
        // EVENT WIRINGS
        addNotes() {
            this.engagementActivityNote = new EngagementActivityNoteModel();
            this.isEditing = true;
        }
        editNotes() {
            this.engagementActivityNote.activityId = this.model.activityId;
            this.engagementActivityNote.notes = this.model.notes;
            this.isEditing = true;
        }
        cancelNotes() {
            this.engagementActivityNote = new EngagementActivityNoteModel();
            this.engagementActivityNote.activityId = this.model.activityId;
            this.engagementActivityNote.notes = this.model.notes;
            this.isEditing = false;
        }
        // CRUD
        saveNotes() {
            this.engagementActivityNote.id = uuidv4();
            this.engagementActivityNote.activityId = this.model.activityId;
            this.engagementActivityNote.notes = this.engagementActivityNote.notes;
            EngagementsModule.SaveActivityNotes(this.engagementActivityNote).then((response) => {
                this.isEditing = false;
                toaster.ShowApiSuccess(response);
            });
        }
        // COMPUTED
        get hasNotes() {
            return this.model.notes != null && this.model.notes != "";
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IEngagementActivity !== "undefined" && IEngagementActivity) === "function" ? _a : Object)
    ], StageActivityNotes.prototype, "model", void 0);
    StageActivityNotes = __decorate([
        Component
    ], StageActivityNotes);
    return StageActivityNotes;
})();
export default StageActivityNotes;
